import Model from "../Model";
import tw from "tailwind-styled-components";
import {
    SideCancelBtn,
    DeleteBtn
} from "../Styles/InputStyles";

const ConfirmModal = ({
    isOpen,
    setOpenModel,
    title = "Confirmation",
    message = "Are you sure you want to continue?",
    loading = false,
    onConfirm,
    onClose,
    confirmBtnText = "Confirm",
    cancelBtnText = "Cancel",
    confirmBtnClassName = "",
}) => {
    if (!isOpen) return null;

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setOpenModel}
            title={title}
        >
            <WarningText>
                {message}
            </WarningText>

            <div className="w-full flex justify-between gap-4 my-4 mt-8">
                <SideCancelBtn
                    type="button"
                    onClick={onClose}
                >
                    {cancelBtnText}
                </SideCancelBtn>

                <DeleteBtn
                    type="button"
                    onClick={onConfirm}
                    disabled={loading}
                    className={confirmBtnClassName}
                >
                    {loading ? "Loading..." : confirmBtnText}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`
    text-gray-500 text-base mb-4
`;

export default ConfirmModal;